(function () {
  function getScopedElements(scope, selector) {
    var root = scope || document;
    var elements = Array.prototype.slice.call(root.querySelectorAll(selector));
    if (root.matches && root.matches(selector)) elements.unshift(root);
    return elements;
  }

  function initMobileMenu(scope) {
    var root = scope || document;
    var toggles = Array.prototype.slice.call(root.querySelectorAll("[data-mobile-menu-toggle]"));
    var menu = root.querySelector("[data-mobile-menu]");
    var header = root.querySelector("[data-vc-header]") || document.querySelector("[data-vc-header]");
    if (!toggles.length || !menu) return;
    if (menu.dataset.vcMobileMenuInitialized === "true") return;
    menu.dataset.vcMobileMenuInitialized = "true";
    var desktopNavigationMinWidth = Number(header && header.dataset.desktopNavigationMinWidth) || 1024;
    var isMenuOpen = !menu.hidden;
    var lastOpener = toggles[0];
    var closeTimer;
    var focusableSelector = [
      "a[href]",
      "button:not([disabled])",
      "input:not([disabled])",
      "select:not([disabled])",
      "textarea:not([disabled])",
      '[tabindex]:not([tabindex="-1"])'
    ].join(",");

    function syncHeaderHeight() {
      if (!header) return;
      document.documentElement.style.setProperty("--vc-header-height", header.offsetHeight + "px");
    }

    function syncToggleState() {
      toggles.forEach(function (toggle) {
        toggle.setAttribute("aria-expanded", String(isMenuOpen));
      });
    }

    function getCloseDelay() {
      return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : 260;
    }

    function getFocusableMenuElements() {
      return Array.prototype.slice.call(menu.querySelectorAll(focusableSelector)).filter(function (element) {
        return !element.hasAttribute("hidden") && element.getAttribute("aria-hidden") !== "true";
      });
    }

    function focusMenuStart() {
      var close = menu.querySelector(".vc-mobile-menu__close");
      var focusableElements = getFocusableMenuElements();
      var target = close || focusableElements[0];
      if (target && typeof target.focus === "function") target.focus();
    }

    function restoreOpenerFocus() {
      var target = lastOpener && document.contains(lastOpener) ? lastOpener : toggles[0];
      if (target && typeof target.focus === "function") target.focus();
    }

    function setMenuOpen(open, options) {
      isMenuOpen = Boolean(open);
      window.clearTimeout(closeTimer);
      document.body.classList.toggle("vc-mobile-menu-open", isMenuOpen);
      syncToggleState();
      menu.hidden = !isMenuOpen;
      document.documentElement.classList.toggle("vc-menu-open", isMenuOpen);

      if (isMenuOpen) {
        menu.hidden = false;
        window.requestAnimationFrame(function () {
          menu.classList.add("is-open");
        });
        window.setTimeout(function () {
          if (isMenuOpen) focusMenuStart();
        }, 50);
        return;
      }

      menu.classList.remove("is-open");
      closeTimer = window.setTimeout(function () {
        if (!isMenuOpen) menu.hidden = true;
      }, getCloseDelay());

      if (options && options.restoreFocus) restoreOpenerFocus();
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener("click", function () {
        if (!isMenuOpen) {
          lastOpener = toggle;
          setMenuOpen(true);
          return;
        }

        setMenuOpen(false, { restoreFocus: true });
      });
    });

    menu.addEventListener("click", function (event) {
      var menuLink = event.target.closest("[data-mobile-menu-link]");
      if (menuLink && menu.contains(menuLink)) setMenuOpen(false, { restoreFocus: true });
    });

    document.addEventListener("keydown", function (event) {
      if (!isMenuOpen) return;

      if (event.key === "Escape") {
        event.preventDefault();
        setMenuOpen(false, { restoreFocus: true });
        return;
      }

      if (event.key !== "Tab") return;

      var focusableElements = getFocusableMenuElements();
      if (!focusableElements.length) {
        event.preventDefault();
        return;
      }

      var first = focusableElements[0];
      var last = focusableElements[focusableElements.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.addEventListener("resize", function () {
      if (!isMenuOpen) return;
      syncHeaderHeight();
      if (window.innerWidth >= desktopNavigationMinWidth) setMenuOpen(false);
    });
    
    syncHeaderHeight();
    syncToggleState();
    document.body.classList.toggle("vc-mobile-menu-open", isMenuOpen);
  }

  function initHeroSliders(scope) {
    getScopedElements(scope, "[data-vc-hero]").forEach(function (slider) {
      if (slider.dataset.vcHeroInitialized === "true") return;

      var slides = Array.prototype.slice.call(slider.querySelectorAll("[data-vc-slide]"));
      var dots = Array.prototype.slice.call(slider.querySelectorAll("[data-vc-dot]"));
      if (!slides.length) return;
      slider.dataset.vcHeroInitialized = "true";

      var active = 0;
      var timer;
      var restartTimer;
      var reducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      var dotClickHandlers = [];
      var interval = Number.parseInt(slider.dataset.vcHeroInterval, 10);
      if (!Number.isFinite(interval) || interval < 3000) interval = 6000;

      function setSlideAccessibility() {
        slides.forEach(function (slide, i) {
          var isActive = i === active;
          slide.setAttribute("aria-hidden", String(!isActive));
          Array.prototype.slice.call(slide.querySelectorAll("a, button, input, select, textarea, video")).forEach(function (item) {
            if (isActive) {
              item.removeAttribute("tabindex");
            } else {
              item.setAttribute("tabindex", "-1");
            }
          });
        });
      }

      function go(index) {
        active = index;
        slides.forEach(function (slide, i) {
          slide.classList.toggle("is-active", i === active);
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle("is-active", i === active);
          dot.setAttribute("aria-current", i === active ? "true" : "false");
        });
        setSlideAccessibility();
      }

      function start() {
        if (slides.length < 2 || reducedMotion) return;
        window.clearInterval(timer);
        timer = window.setInterval(function () {
          go((active + 1) % slides.length);
        }, interval);
      }

      function pause() {
        window.clearInterval(timer);
      }

      dots.forEach(function (dot, index) {
        var handleDotClick = function () {
          pause();
          go(index);
          window.clearTimeout(restartTimer);
          restartTimer = window.setTimeout(start, 10000);
        };
        dot.addEventListener("click", handleDotClick);
        dotClickHandlers.push({ dot: dot, handleDotClick: handleDotClick });
      });

      slider.addEventListener("mouseenter", pause);
      slider.addEventListener("mouseleave", start);
      slider.addEventListener("focusin", pause);
      slider.addEventListener("focusout", start);

      go(0);
      start();

      slider.vcHeroCleanup = function () {
        window.clearInterval(timer);
        window.clearTimeout(restartTimer);
        dotClickHandlers.forEach(function (item) {
          item.dot.removeEventListener("click", item.handleDotClick);
        });
        slider.removeEventListener("mouseenter", pause);
        slider.removeEventListener("mouseleave", start);
        slider.removeEventListener("focusin", pause);
        slider.removeEventListener("focusout", start);
        delete slider.dataset.vcHeroInitialized;
        delete slider.vcHeroCleanup;
      };
    });
  }

  function cleanupHeroSliders(scope) {
    getScopedElements(scope, "[data-vc-hero]").forEach(function (slider) {
      if (typeof slider.vcHeroCleanup === "function") slider.vcHeroCleanup();
    });
  }

  function initAnimatedEyes(scope) {
    getScopedElements(scope, "[data-vc-eye]").forEach(function (eye) {
      if (eye.dataset.vcEyeInitialized === "true") return;

      var pupil = eye.querySelector("[data-vc-eye-pupil]");
      if (!pupil) return;
      eye.dataset.vcEyeInitialized = "true";

      var trackingRadius = 100;
      var isHovered = false;
      var isTracking = false;
      var lookTimer;
      var blinkTimer;
      var timeouts = [];

      function queueTimeout(callback, delay) {
        var id = window.setTimeout(function () {
          timeouts = timeouts.filter(function (timeout) {
            return timeout !== id;
          });
          callback();
        }, delay);
        timeouts.push(id);
        return id;
      }

      function setLook(x, y, tracking) {
        isTracking = Boolean(tracking);
        eye.classList.toggle("is-tracking", isTracking);
        pupil.style.transform = "translate(" + (x * 1.2) + "px, " + (y * 1.2) + "px)";
      }

      function handleMouseMove(event) {
        var rect = eye.getBoundingClientRect();
        var centerX = rect.left + rect.width / 2;
        var centerY = rect.top + rect.height / 2;
        var distanceX = event.clientX - centerX;
        var distanceY = event.clientY - centerY;
        var distance = Math.sqrt(distanceX * distanceX + distanceY * distanceY);

        if (distance < trackingRadius) {
          setLook((distanceX / trackingRadius) * 2, (distanceY / trackingRadius) * 1.2, true);
        } else if (isTracking) {
          isTracking = false;
          eye.classList.remove("is-tracking");
        }
      }

      function scheduleLook() {
        window.clearTimeout(lookTimer);
        lookTimer = queueTimeout(function () {
          if (!isHovered && !isTracking) {
            if (Math.random() < 0.2) {
              setLook(0, 0, false);
            } else {
              var intensity = 0.5 + Math.random() * 1.2;
              var randomX = (Math.random() - 0.5) * 2 * intensity;
              var randomY = (Math.random() - 0.5) * 1.2 * intensity;
              setLook(randomX, randomY, false);

              if (Math.random() < 0.15) {
                queueTimeout(function () {
                  if (!isHovered && !isTracking) {
                    setLook((Math.random() - 0.5) * 2.5, (Math.random() - 0.5) * 1.5, false);
                  }
                }, 200);
              }
            }
          }

          scheduleLook();
        }, 800 + Math.random() * 1700);
      }

      function blink() {
        eye.classList.add("is-blinking");
        queueTimeout(function () { eye.classList.remove("is-blinking"); }, 120);
        if (Math.random() < 0.2) {
          queueTimeout(function () {
            eye.classList.add("is-blinking");
            queueTimeout(function () { eye.classList.remove("is-blinking"); }, 100);
          }, 250);
        }
      }

      function scheduleBlink() {
        blinkTimer = queueTimeout(function () {
          blink();
          scheduleBlink();
        }, 3000 + Math.random() * 3000);
      }

      function handleMouseEnter() {
        isHovered = true;
      }

      function handleMouseLeave() {
        isHovered = false;
        setLook(0, 0, false);
      }

      window.addEventListener("mousemove", handleMouseMove);
      eye.addEventListener("mouseenter", handleMouseEnter);
      eye.addEventListener("mouseleave", handleMouseLeave);
      scheduleLook();
      scheduleBlink();

      eye.vcEyeCleanup = function () {
        window.removeEventListener("mousemove", handleMouseMove);
        eye.removeEventListener("mouseenter", handleMouseEnter);
        eye.removeEventListener("mouseleave", handleMouseLeave);
        window.clearTimeout(lookTimer);
        window.clearTimeout(blinkTimer);
        timeouts.forEach(function (timeout) {
          window.clearTimeout(timeout);
        });
        eye.classList.remove("is-tracking", "is-blinking");
        if (pupil) pupil.style.transform = "";
        delete eye.dataset.vcEyeInitialized;
        delete eye.vcEyeCleanup;
      };
    });
  }

  function cleanupAnimatedEyes(scope) {
    getScopedElements(scope, "[data-vc-eye]").forEach(function (eye) {
      if (typeof eye.vcEyeCleanup === "function") eye.vcEyeCleanup();
    });
  }

  var registryCardCounter = 0;

  function registryFragmentFromHtml(html) {
    var template = document.createElement("template");
    template.innerHTML = String(html || "").trim();
    var fragment = template.content.querySelector("[data-vita-registry-product-fragment]");
    return fragment ? fragment.outerHTML : "";
  }

  function registryCardPayload(target) {
    return {
      productGid: target.dataset.productGid || "",
      variantGid: target.dataset.variantGid || "",
      productTitle: target.dataset.productTitle || "",
      productHandle: target.dataset.productHandle || "",
      variantTitle: target.dataset.variantTitle || "",
      vendor: target.dataset.productVendor || "",
      imageUrl: target.dataset.imageUrl || "",
      price: target.dataset.variantPrice || "",
      productType: target.dataset.productType || ""
    };
  }

  function syncRegistryCardFields(form, payload) {
    Object.keys(payload).forEach(function (name) {
      var field = form.querySelector('[name="' + name + '"]');
      if (field) field.value = payload[name] || "";
    });
  }

  function prepareRegistryCardFragment(target) {
    var dialog = target.querySelector(".vita-registry-pdp-cta__dialog");
    var title = target.querySelector("#vita-registry-pdp-modal-title");
    if (!dialog || !title) return;

    registryCardCounter += 1;
    title.id = "vita-registry-card-modal-title-" + registryCardCounter;
    dialog.setAttribute("aria-labelledby", title.id);
  }

  function bindRegistryCardSuccess(target) {
    var success = target.querySelector("[data-vita-registry-success]");
    if (!success || success.dataset.vitaRegistrySuccessBound === "true") return;

    success.dataset.vitaRegistrySuccessBound = "true";
    window.setTimeout(function () {
      success.dataset.vitaRegistrySuccessLeaving = "true";
    }, 2400);
    window.setTimeout(function () {
      success.remove();
    }, 3100);
  }

  function bindRegistryCardFragment(target) {
    bindRegistryCardSuccess(target);

    var form = target.querySelector("[data-vita-registry-product-form]");
    if (!form || form.dataset.vitaRegistryCardFormInitialized === "true") return;
    form.dataset.vitaRegistryCardFormInitialized = "true";

    var modal = form.querySelector("[data-vita-registry-modal]");
    var modalOpenButton = form.querySelector("[data-vita-registry-modal-open]");
    var modalSubmitButton = form.querySelector("[data-vita-registry-modal-submit]");
    var modalCloseButtons = Array.prototype.slice.call(form.querySelectorAll("[data-vita-registry-modal-close]"));
    var registryIdField = form.querySelector('[name="registryId"]');

    function selectedRegistryChoice() {
      return form.querySelector("[data-vita-registry-choice]:checked");
    }

    function handleRegistryModalKeydown(event) {
      if (event.key === "Escape") closeRegistryModal();
    }

    function closeRegistryModal() {
      if (!modal) return;
      modal.hidden = true;
      document.removeEventListener("keydown", handleRegistryModalKeydown);
      if (modalOpenButton) modalOpenButton.focus();
    }

    function openRegistryModal() {
      if (!modal) return;
      modal.hidden = false;
      document.addEventListener("keydown", handleRegistryModalKeydown);
      var selectedChoice = selectedRegistryChoice();
      var focusTarget = selectedChoice || modalSubmitButton || modal.querySelector("button");
      if (focusTarget) focusTarget.focus();
    }

    syncRegistryCardFields(form, registryCardPayload(target));

    if (modalOpenButton) {
      modalOpenButton.addEventListener("click", function (event) {
        event.preventDefault();
        syncRegistryCardFields(form, registryCardPayload(target));
        openRegistryModal();
      });
    }

    modalCloseButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        closeRegistryModal();
      });
    });

    if (modalSubmitButton) {
      modalSubmitButton.addEventListener("click", function () {
        var choice = selectedRegistryChoice();
        if (choice && registryIdField) registryIdField.value = choice.value;
        closeRegistryModal();
        if (form.requestSubmit) {
          form.requestSubmit();
        } else {
          form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
        }
      });
    }

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      syncRegistryCardFields(form, registryCardPayload(target));
      closeRegistryModal();
      target.dataset.loading = "true";

      fetch(form.action, {
        method: "POST",
        body: new FormData(form),
        headers: {
          "Accept": "text/html"
        }
      }).then(function (response) {
        return response.text();
      }).then(function (html) {
        var fragment = registryFragmentFromHtml(html);
        if (!fragment) {
          target.hidden = true;
          return;
        }

        target.innerHTML = fragment;
        target.hidden = false;
        target.dataset.loading = "false";
        prepareRegistryCardFragment(target);
        bindRegistryCardFragment(target);
      }).catch(function () {
        target.dataset.loading = "false";
      });
    });
  }

  function initRegistryProductCards(scope) {
    getScopedElements(scope, "[data-vita-registry-card-target]").forEach(function (target) {
      if (target.dataset.vitaRegistryCardInitialized === "true") return;
      target.dataset.vitaRegistryCardInitialized = "true";

      var actions = target.closest("[data-vita-registry-card-actions]");
      var fallbackForm = actions ? actions.querySelector("[data-vita-registry-cart-form]") : null;
      var endpoint = target.dataset.endpoint || "/apps/registry/product-add";
      var url = new URL(endpoint, window.location.origin);
      var payload = registryCardPayload(target);

      if (actions) actions.classList.add("is-registry-checking");

      Object.keys(payload).forEach(function (name) {
        if (payload[name]) url.searchParams.set(name, payload[name]);
      });

      fetch(url.toString(), {
        headers: {
          "Accept": "text/html"
        }
      }).then(function (response) {
        return response.text();
      }).then(function (html) {
        var fragment = registryFragmentFromHtml(html);
        if (!fragment) {
          if (actions) actions.classList.remove("is-registry-checking");
          target.hidden = true;
          return;
        }

        if (fallbackForm) fallbackForm.hidden = true;
        if (actions) {
          actions.classList.remove("is-registry-checking");
          actions.classList.add("is-registry-ready");
        }
        target.innerHTML = fragment;
        target.hidden = false;
        prepareRegistryCardFragment(target);
        bindRegistryCardFragment(target);
      }).catch(function () {
        if (actions) actions.classList.remove("is-registry-checking");
        target.hidden = true;
      });
    });
  }

  function initCartDrawer() {
    var drawer = document.querySelector("[data-vc-cart-drawer]");
    if (!drawer) return;

    var body = drawer.querySelector("[data-vc-cart-body]");
    var footer = drawer.querySelector("[data-vc-cart-footer]");
    var subtotal = drawer.querySelector("[data-vc-cart-subtotal]");
    var message = drawer.querySelector("[data-vc-cart-message]");
    var drawerHeader = drawer.querySelector(".vc-cart-drawer__header");
    var triggers = Array.prototype.slice.call(document.querySelectorAll("[data-vc-cart-trigger]"));
    var closeButtons = Array.prototype.slice.call(drawer.querySelectorAll("[data-vc-cart-close]"));
    var noteInput = drawer.querySelector("[data-vc-cart-note]");
    var buyerNameInput = drawer.querySelector("[data-vc-cart-gift-buyer-name]");
    var giftCheckbox = drawer.querySelector("[data-vc-cart-is-gift]");
    var giftFields = drawer.querySelector("[data-vc-cart-gift-fields]");
    var giftToggle = drawer.querySelector("[data-vc-cart-gift-toggle]");
    var giftDone = drawer.querySelector("[data-vc-cart-gift-done]");
    var giftRowTitle = drawer.querySelector("[data-vc-cart-gift-row-title]");
    var giftSummary = drawer.querySelector("[data-vc-cart-gift-summary]");
    var giftToLine = drawer.querySelector("[data-vc-cart-gift-recipient-line]");
    var giftRowEdit = drawer.querySelector("[data-vc-cart-gift-row-edit]");
    var giftHelper = drawer.querySelector("[data-vc-cart-gift-helper]");
    var toNameInput = drawer.querySelector("[data-vc-cart-gift-recipient-name]");
    var toMailInput = drawer.querySelector("[data-vc-cart-gift-recipient-email]");
    var recipientRow = drawer.querySelector("[data-vc-cart-gift-recipient]");
    var mailHint = drawer.querySelector("[data-vc-cart-gift-email-hint]");
    var noteStatus = drawer.querySelector("[data-vc-cart-note-status]");
    var noteCount = drawer.querySelector("[data-vc-cart-note-count]");
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";
    var cartUrl = root + "cart.js";
    var addUrl = root + "cart/add.js";
    var changeUrl = root + "cart/change.js";
    var noteSavedMessage = drawer.getAttribute("data-vc-cart-note-saved-message") || "";
    var noteSavingMessage = drawer.getAttribute("data-vc-cart-note-saving-message") || "";
    var noteNotSavedMessage = drawer.getAttribute("data-vc-cart-note-not-saved-message") || "";
    var noteErrorMessage = drawer.getAttribute("data-vc-cart-note-error-message") || "";
    var updateUrl = root + "cart/update.js";
    var noteState = drawer.vcCartNoteState;
    if (!noteState) {
      noteState = {
        desiredValue: noteInput ? noteInput.value : "",
        desiredBuyerName: buyerNameInput ? buyerNameInput.value : "",
        desiredRecipientName: toNameInput ? toNameInput.value : "",
        desiredRecipientEmail: toMailInput ? toMailInput.value : "",
        desiredIsGift: giftCheckbox ? giftCheckbox.checked : false,
        drainPromise: undefined,
        giftInteracted: false,
        inFlightValue: undefined,
        persistedValue: noteInput ? noteInput.value : "",
        persistedBuyerName: buyerNameInput ? buyerNameInput.getAttribute("value") || "" : "",
        persistedRecipientName: toNameInput ? toNameInput.getAttribute("value") || "" : "",
        persistedRecipientEmail: toMailInput ? toMailInput.getAttribute("value") || "" : "",
        persistedIsGift: giftCheckbox ? giftCheckbox.checked : false,
        saveTimer: undefined
      };
      drawer.vcCartNoteState = noteState;
    }

    function formatMoney(cents, currency) {
      var amount = Number(cents || 0) / 100;
      try {
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: currency || "USD"
        }).format(amount);
      } catch (error) {
        return "$" + amount.toFixed(2);
      }
    }

    function escapeHTML(value) {
      return String(value || "").replace(/[&<>"']/g, function (character) {
        return {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;"
        }[character];
      });
    }

    function sizedImageUrl(url, width) {
      if (!url) return "";
      return url + (url.indexOf("?") === -1 ? "?" : "&") + "width=" + width;
    }

    var messageDismissTimer;
    var messageHideTimer;
    var messageOwner = "";

    function showMessage(text, isError, owner) {
      if (!message) return;
      window.clearTimeout(messageDismissTimer);
      window.clearTimeout(messageHideTimer);
      message.classList.remove("is-dismissing");
      message.textContent = text || "";
      message.hidden = !text;
      message.classList.toggle("is-error", Boolean(isError));
      messageOwner = text ? owner || "" : "";
      syncGiftPanelOffset();

      if (text && !isError) {
        messageDismissTimer = window.setTimeout(function () {
          message.classList.add("is-dismissing");
          messageHideTimer = window.setTimeout(function () {
            showMessage("");
          }, 300);
        }, 4000);
      }
    }

    function clearGiftSaveMessage() {
      if (messageOwner === "gift-save") showMessage("");
    }

    function setOpen(open) {
      if (!open && drawer.classList.contains("is-open") && (noteState.drainPromise || cartGiftDetailsAreDirty())) {
        flushCartNote().catch(function () {});
      }
      drawer.classList.toggle("is-open", open);
      drawer.setAttribute("aria-hidden", open ? "false" : "true");
      document.documentElement.classList.toggle("vc-cart-drawer-open", open);
      document.body.classList.toggle("vc-cart-drawer-open", open);
      triggers.forEach(function (trigger) {
        trigger.setAttribute("aria-expanded", open ? "true" : "false");
      });
      if (open) {
        window.setTimeout(function () {
          var close = drawer.querySelector(".vc-cart-drawer__close");
          if (close) close.focus();
        }, 50);
      }
    }

    function updateCounts(count) {
      document.querySelectorAll("[data-vc-cart-count]").forEach(function (counter) {
        counter.textContent = String(count || 0);
        counter.hidden = !count;
      });
    }

    function renderProperties(properties) {
      if (!properties || Object.keys(properties).length === 0) return "";
      var rows = Object.keys(properties).filter(function (key) {
        return key.charAt(0) !== "_" && properties[key];
      }).map(function (key) {
        return "<div><dt>" + escapeHTML(key) + "</dt><dd>" + escapeHTML(properties[key]) + "</dd></div>";
      });
      if (!rows.length) return "";
      return "<dl>" + rows.join("") + "</dl>";
    }

    function renderItem(item, currency) {
      var image = item.image || (item.featured_image && item.featured_image.url);
      var title = item.product_title || item.title;
      var variant = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
      var unitPrice = formatMoney(item.final_price || item.price, currency);
      var itemKey = item.key || item.id;
      var quantity = Number(item.quantity || 0);
      var itemLabel = title || "item";
      var imageMarkup = image
        ? '<img src="' + escapeHTML(sizedImageUrl(image, 180)) + '" alt="' + escapeHTML(title) + '" loading="lazy">'
        : '<div class="vc-cart-drawer__placeholder"></div>';

      return [
        '<li class="vc-cart-drawer__item">',
        '<a class="vc-cart-drawer__item-image" href="' + escapeHTML(item.url || "/") + '">' + imageMarkup + "</a>",
        '<div class="vc-cart-drawer__item-info">',
        '<h3><a href="' + escapeHTML(item.url || "/") + '">' + escapeHTML(title) + "</a></h3>",
        variant ? "<p>" + escapeHTML(variant) + "</p>" : "",
        renderProperties(item.properties),
        '<span class="vc-cart-drawer__item-price">' + escapeHTML(quantity) + " x " + escapeHTML(unitPrice) + "</span>",
        '<div class="vc-cart-drawer__item-actions" data-vc-cart-item data-vc-cart-key="' + escapeHTML(itemKey) + '" data-vc-cart-title="' + escapeHTML(itemLabel) + '">',
        '<div class="vc-cart-drawer__quantity" role="group" aria-label="Quantity for ' + escapeHTML(itemLabel) + '">',
        '<button type="button" aria-label="Decrease quantity for ' + escapeHTML(itemLabel) + '" data-vc-cart-quantity-decrease>-</button>',
        '<input type="number" min="0" inputmode="numeric" value="' + escapeHTML(quantity) + '" aria-label="Quantity for ' + escapeHTML(itemLabel) + '" data-vc-cart-quantity-input>',
        '<button type="button" aria-label="Increase quantity for ' + escapeHTML(itemLabel) + '" data-vc-cart-quantity-increase>+</button>',
        "</div>",
        '<button type="button" class="vc-cart-drawer__remove" data-vc-cart-remove>Remove</button>',
        "</div>",
        "</div>",
        "</li>"
      ].join("");
    }

    function normalizeQuantity(value, fallback) {
      var parsed = parseInt(value, 10);
      if (isNaN(parsed)) parsed = fallback || 0;
      return Math.max(0, parsed);
    }

    function setCartItemBusy(itemContainer, busy) {
      if (!itemContainer) return;
      itemContainer.classList.toggle("is-updating", busy);
      Array.prototype.slice.call(itemContainer.querySelectorAll("button, input")).forEach(function (control) {
        control.disabled = busy;
      });
    }

    function changeCartItem(itemContainer, quantity) {
      var key = itemContainer ? itemContainer.getAttribute("data-vc-cart-key") : "";
      var title = itemContainer ? itemContainer.getAttribute("data-vc-cart-title") : "Item";
      var nextQuantity = normalizeQuantity(quantity, 1);

      if (!key) {
        showMessage("Unable to update this item.", true);
        return Promise.resolve();
      }

      setCartItemBusy(itemContainer, true);
      showMessage("");

      return fetch(changeUrl, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          id: key,
          quantity: nextQuantity
        })
      }).then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok) {
            throw new Error(payload.description || payload.message || "Unable to update cart.");
          }
          return payload;
        });
      }).then(function (cart) {
        renderCart(cart);
        showMessage(nextQuantity === 0 ? title + " removed from your bag." : title + " quantity updated.");
      }).catch(function (error) {
        showMessage(error.message || "Unable to update cart.", true);
        setCartItemBusy(itemContainer, false);
      });
    }

    function setNoteSaving(saving) {
      [noteInput, buyerNameInput, toNameInput, toMailInput].filter(Boolean).forEach(function (field) {
        field.setAttribute("aria-busy", String(saving));
      });
      if (giftCheckbox) giftCheckbox.setAttribute("aria-busy", String(saving));
    }

    var NOTE_LIMIT = 250;
    var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    var giftInputs = [noteInput, buyerNameInput, toNameInput, toMailInput].filter(Boolean);

    function readAttr(name, fallback) {
      return drawer.getAttribute(name) || fallback || "";
    }

    function giftHasContent() {
      return giftInputs.some(function (field) { return field.value.trim(); });
    }

    function persistedGiftHasContent() {
      return [
        noteState.persistedValue,
        noteState.persistedBuyerName,
        noteState.persistedRecipientName,
        noteState.persistedRecipientEmail
      ].some(function (value) { return String(value || "").trim(); });
    }

    function giftIntentIsActive() {
      return Boolean(noteState.giftInteracted || noteState.persistedIsGift || persistedGiftHasContent());
    }

    function emailLooksWrong() {
      var value = toMailInput ? toMailInput.value.trim() : "";
      return Boolean(value) && !EMAIL_RE.test(value);
    }

    function syncIsGift() {
      if (giftCheckbox) giftCheckbox.checked = giftIntentIsActive() && giftHasContent();
    }

    function giftPreview() {
      var body = (noteInput.value || "").trim().replace(/\s+/g, " ");
      var name = (buyerNameInput.value || "").trim();
      if (body && name) return "\u201C" + body + "\u201D \u2014 " + name;
      if (body) return "\u201C" + body + "\u201D";
      return name ? [readAttr("data-vc-cart-gift-signed-prefix"), name].filter(Boolean).join(" ") : "";
    }

    function recipientLine() {
      var name = toNameInput ? toNameInput.value.trim() : "";
      var mail = toMailInput ? toMailInput.value.trim() : "";
      var prefix = readAttr("data-vc-cart-gift-recipient-prefix");
      var recipient = prefix ? prefix + " " : "";
      if (name && mail) return recipient + name + " \u00B7 " + mail;
      return name ? recipient + name : mail ? recipient + mail : "";
    }

    function renderGiftRow() {
      if (!giftToggle) return;
      var filled = giftIntentIsActive() && giftHasContent();
      var line = recipientLine();
      var badEmail = emailLooksWrong();
      giftToggle.classList.toggle("is-filled", filled);
      if (giftRowTitle) giftRowTitle.textContent = filled
        ? badEmail
          ? readAttr("data-vc-cart-gift-email-title")
          : readAttr("data-vc-cart-gift-added-label")
        : readAttr("data-vc-cart-gift-add-label");
      if (giftSummary) giftSummary.textContent = filled
        ? giftPreview()
        : readAttr("data-vc-cart-gift-add-help");
      if (giftToLine) {
        giftToLine.textContent = filled ? line : "";
        giftToLine.hidden = !(filled && line);
      }
      if (giftRowEdit) giftRowEdit.hidden = !filled;
    }

    function renderNoteMeta(state) {
      if (!noteInput) return;
      var left = NOTE_LIMIT - noteInput.value.length;
      var badEmail = emailLooksWrong();

      if (noteCount) {
        noteCount.textContent = left <= 60 ? left + " " + readAttr("data-vc-cart-note-left-label") : "";
        noteCount.classList.toggle("is-warning", left <= 20);
      }
      if (mailHint) mailHint.hidden = !badEmail;
      if (recipientRow) recipientRow.classList.toggle("is-invalid", badEmail);
      if (toMailInput) toMailInput.setAttribute("aria-invalid", badEmail ? "true" : "false");
      if (noteStatus) {
        noteStatus.textContent = state === "error" ? noteNotSavedMessage
          : badEmail ? readAttr("data-vc-cart-note-email-message")
          : state === "saving" ? noteSavingMessage
          : state === "saved" ? noteSavedMessage
          : "";
        noteStatus.classList.toggle("is-saved", state === "saved" && !badEmail);
        noteStatus.classList.toggle("is-error", (state === "error" || badEmail));
      }
      if (giftHelper) {
        giftHelper.textContent = (toMailInput && toMailInput.value.trim() && !badEmail)
          ? readAttr("data-vc-cart-gift-autosave-email")
          : readAttr("data-vc-cart-gift-autosave");
      }
    }

    function syncGiftPanelOffset() {
      if (!drawerHeader) return;
      drawer.style.setProperty("--vc-cart-drawer-header-height", drawerHeader.offsetHeight + "px");
      drawer.style.setProperty("--vc-cart-drawer-message-height", message && !message.hidden ? message.offsetHeight + "px" : "0px");
      drawer.style.setProperty("--vc-cart-drawer-footer-height", footer ? footer.offsetHeight + "px" : "0px");
    }

    function setGiftOpen(open, restoreFocus) {
      if (giftFields) giftFields.hidden = !open;
      if (giftToggle) {
        giftToggle.hidden = open;
        giftToggle.setAttribute("aria-expanded", open ? "true" : "false");
      }
      if (body) body.inert = open;
      if (footer && footer.children) {
        Array.prototype.slice.call(footer.children).forEach(function (child) {
          if (child !== giftFields) child.inert = open;
        });
      }
      if (open) syncGiftPanelOffset();
      if (open && toNameInput) toNameInput.focus();
      if (!open && giftToggle && restoreFocus !== false) giftToggle.focus();
    }

    function cartGiftDetailsAreDirty() {
      return (giftIntentIsActive() && (
        noteState.desiredValue !== noteState.persistedValue
        || noteState.desiredBuyerName !== noteState.persistedBuyerName
        || noteState.desiredRecipientName !== noteState.persistedRecipientName
        || noteState.desiredRecipientEmail !== noteState.persistedRecipientEmail
      ))
        || noteState.desiredIsGift !== noteState.persistedIsGift;
    }

    function syncCartNote(cart) {
      if (
        (!noteInput && !buyerNameInput && !toNameInput && !toMailInput && !giftCheckbox)
        || noteState.drainPromise
        || noteState.inFlightValue !== undefined
        || cartGiftDetailsAreDirty()
      ) return;

      if (noteInput) {
        noteState.persistedValue = String((cart && cart.note) || "");
        noteState.desiredValue = noteState.persistedValue;
        noteInput.value = noteState.persistedValue;
      }

      if (buyerNameInput) {
        noteState.persistedBuyerName = String((cart && cart.attributes && cart.attributes["Gift buyer name"]) || "");
        noteState.desiredBuyerName = noteState.persistedBuyerName;
        buyerNameInput.value = noteState.persistedBuyerName;
      }

      if (toNameInput) {
        noteState.persistedRecipientName = String((cart && cart.attributes && cart.attributes["Gift recipient name"]) || "");
        noteState.desiredRecipientName = noteState.persistedRecipientName;
        toNameInput.value = noteState.persistedRecipientName;
      }

      if (toMailInput) {
        noteState.persistedRecipientEmail = String((cart && cart.attributes && cart.attributes["Gift recipient email"]) || "");
        noteState.desiredRecipientEmail = noteState.persistedRecipientEmail;
        toMailInput.value = noteState.persistedRecipientEmail;
      }

      if (giftCheckbox) {
        syncIsGift();
        noteState.persistedIsGift = Boolean(cart && cart.attributes && cart.attributes["This is a gift"] === "Yes");
        noteState.desiredIsGift = giftCheckbox.checked;
      }
      renderGiftRow();
      renderNoteMeta();
      if (cartGiftDetailsAreDirty()) scheduleCartNoteSave();
    }

    function saveCartNote() {
      window.clearTimeout(noteState.saveTimer);
      if (!noteInput && !buyerNameInput && !toNameInput && !toMailInput && !giftCheckbox) return Promise.resolve();
      if (noteInput) noteState.desiredValue = noteInput.value;
      if (buyerNameInput) noteState.desiredBuyerName = buyerNameInput.value;
      if (toNameInput) noteState.desiredRecipientName = toNameInput.value;
      if (toMailInput) noteState.desiredRecipientEmail = toMailInput.value;
      syncIsGift();
      if (giftCheckbox) noteState.desiredIsGift = giftCheckbox.checked;

      if (noteState.drainPromise) return noteState.drainPromise;
      if (!cartGiftDetailsAreDirty()) {
        clearGiftSaveMessage();
        renderNoteMeta("saved");
        return Promise.resolve();
      }

      setNoteSaving(true);
      clearGiftSaveMessage();
      renderNoteMeta("saving");

      function drainCartNote() {
        if (!cartGiftDetailsAreDirty()) return Promise.resolve();

        var note = noteState.desiredValue;
        var buyerName = noteState.desiredBuyerName;
        var recipientName = noteState.desiredRecipientName;
        var recipientEmail = noteState.desiredRecipientEmail;
        var isGift = noteState.desiredIsGift;
        noteState.inFlightValue = {
          buyerName: buyerName,
          isGift: isGift,
          note: note
        };

        return fetch(updateUrl, {
          method: "POST",
          headers: {
            "Accept": "application/json",
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            note: note,
            attributes: {
              "This is a gift": isGift ? "Yes" : "",
              "Gift buyer name": buyerName,
              "Gift recipient name": recipientName,
              "Gift recipient email": recipientEmail
            }
          })
        }).then(function (response) {
          if (!response.ok) throw new Error("Unable to save cart note.");
          return response.json();
        }).then(function (cart) {
          noteState.persistedValue = typeof cart.note === "string" ? cart.note : note;
          noteState.persistedBuyerName = cart.attributes && typeof cart.attributes["Gift buyer name"] === "string"
            ? cart.attributes["Gift buyer name"]
            : buyerName;
          noteState.persistedRecipientName = cart.attributes && typeof cart.attributes["Gift recipient name"] === "string"
            ? cart.attributes["Gift recipient name"]
            : recipientName;
          noteState.persistedRecipientEmail = cart.attributes && typeof cart.attributes["Gift recipient email"] === "string"
            ? cart.attributes["Gift recipient email"]
            : recipientEmail;
          if (noteInput && noteInput.value === note) noteInput.value = noteState.persistedValue;
          if (buyerNameInput && buyerNameInput.value === buyerName) buyerNameInput.value = noteState.persistedBuyerName;
          if (toNameInput && toNameInput.value === recipientName) toNameInput.value = noteState.persistedRecipientName;
          if (toMailInput && toMailInput.value === recipientEmail) toMailInput.value = noteState.persistedRecipientEmail;
          noteState.persistedIsGift = cart.attributes && typeof cart.attributes["This is a gift"] === "string"
            ? cart.attributes["This is a gift"] === "Yes"
            : isGift;
          syncIsGift();
          if (noteInput) noteState.desiredValue = noteInput.value;
          if (buyerNameInput) noteState.desiredBuyerName = buyerNameInput.value;
          if (toNameInput) noteState.desiredRecipientName = toNameInput.value;
          if (toMailInput) noteState.desiredRecipientEmail = toMailInput.value;
          if (giftCheckbox) noteState.desiredIsGift = giftCheckbox.checked;
          noteState.inFlightValue = undefined;
          renderGiftRow();
          return drainCartNote();
        }, function (error) {
          var hasNewerDetails = noteState.desiredValue !== note
            || noteState.desiredBuyerName !== buyerName
            || noteState.desiredRecipientName !== recipientName
            || noteState.desiredRecipientEmail !== recipientEmail
            || noteState.desiredIsGift !== isGift;
          noteState.inFlightValue = undefined;
          if (hasNewerDetails) return drainCartNote();
          throw error;
        });
      }

      noteState.drainPromise = drainCartNote().then(function () {
        renderNoteMeta("saved");
        renderGiftRow();
      }).catch(function (error) {
        showMessage(noteErrorMessage, true, "gift-save");
        renderNoteMeta("error");
        throw error;
      }).finally(function () {
        noteState.inFlightValue = undefined;
        noteState.drainPromise = undefined;
        setNoteSaving(false);
      });

      return noteState.drainPromise;
    }

    function flushCartNote() {
      window.clearTimeout(noteState.saveTimer);
      return saveCartNote();
    }

    function scheduleCartNoteSave() {
      window.clearTimeout(noteState.saveTimer);
      noteState.saveTimer = window.setTimeout(function () {
        saveCartNote().catch(function () {});
      }, 600);
    }

    function renderCart(cart) {
      syncCartNote(cart);
      updateCounts(cart.item_count);
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price, cart.currency);
      if (footer) footer.hidden = cart.item_count === 0;
      if (!body) return;

      if (cart.item_count === 0) {
        body.innerHTML = '<div class="vc-cart-drawer__empty" data-vc-cart-empty><p>Your bag is empty.</p><button type="button" data-vc-cart-close>Continue Shopping</button></div>';
        closeButtons = Array.prototype.slice.call(drawer.querySelectorAll("[data-vc-cart-close]"));
        bindCloseButtons();
        return;
      }

      body.innerHTML = '<ul class="vc-cart-drawer__items" data-vc-cart-items>' + cart.items.map(function (item) {
        return renderItem(item, cart.currency);
      }).join("") + "</ul>";
    }

    function fetchCart() {
      return fetch(cartUrl, {
        headers: {
          "Accept": "application/json"
        }
      }).then(function (response) {
        if (!response.ok) throw new Error("Unable to load cart.");
        return response.json();
      }).then(function (cart) {
        renderCart(cart);
        return cart;
      });
    }

    function bindCloseButtons() {
      closeButtons.forEach(function (button) {
        if (button.dataset.vcCartCloseInitialized === "true") return;
        button.dataset.vcCartCloseInitialized = "true";
        button.addEventListener("click", function () {
          setOpen(false);
        });
      });
    }

    triggers.forEach(function (trigger) {
      if (trigger.dataset.vcCartTriggerInitialized === "true") return;
      trigger.dataset.vcCartTriggerInitialized = "true";
      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        showMessage("");
        fetchCart().finally(function () {
          setOpen(true);
        });
      });
    });

    bindCloseButtons();

    if (drawer.dataset.vcCartDrawerInitialized !== "true") {
      drawer.dataset.vcCartDrawerInitialized = "true";
      document.addEventListener("keydown", function (event) {
        if (event.key === "Escape" && drawer.classList.contains("is-open")) {
          setOpen(false);
        }
      });
    }

    if (body && body.dataset.vcCartActionsInitialized !== "true") {
      body.dataset.vcCartActionsInitialized = "true";

      body.addEventListener("click", function (event) {
        var removeButton = event.target.closest("[data-vc-cart-remove]");
        var quantityButton = event.target.closest("[data-vc-cart-quantity-decrease], [data-vc-cart-quantity-increase]");
        var itemContainer = event.target.closest("[data-vc-cart-item]");

        if (!itemContainer) return;

        if (removeButton) {
          event.preventDefault();
          changeCartItem(itemContainer, 0);
          return;
        }

        if (quantityButton) {
          var input = itemContainer.querySelector("[data-vc-cart-quantity-input]");
          if (!input) return;

          event.preventDefault();
          var currentQuantity = normalizeQuantity(input.value, 1);
          var nextQuantity = quantityButton.hasAttribute("data-vc-cart-quantity-increase")
            ? currentQuantity + 1
            : currentQuantity - 1;

          input.value = Math.max(0, nextQuantity);
          changeCartItem(itemContainer, input.value);
        }
      });

      body.addEventListener("change", function (event) {
        var input = event.target.closest("[data-vc-cart-quantity-input]");
        if (!input) return;

        var itemContainer = input.closest("[data-vc-cart-item]");
        if (!itemContainer) return;

        input.value = normalizeQuantity(input.value, 1);
        changeCartItem(itemContainer, input.value);
      });
    }

    if (!drawer.vcCartGiftBound) {
      drawer.vcCartGiftBound = true;

      window.addEventListener("resize", function () {
        if (giftFields && !giftFields.hidden) syncGiftPanelOffset();
      });

      if (giftToggle) giftToggle.addEventListener("click", function () {
        noteState.giftInteracted = true;
        syncIsGift();
        if (giftCheckbox) noteState.desiredIsGift = giftCheckbox.checked;
        setGiftOpen(true);
      });
      if (giftDone) giftDone.addEventListener("click", function () {
        flushCartNote().then(function () {
          setGiftOpen(false, drawer.classList.contains("is-open"));
          renderGiftRow();
        }).catch(function () {});
      });

      giftInputs.forEach(function (field) {
        field.addEventListener("input", function () {
          if (!giftIntentIsActive()) return;
          syncIsGift();
          if (noteInput) noteState.desiredValue = noteInput.value;
          if (buyerNameInput) noteState.desiredBuyerName = buyerNameInput.value;
          if (toNameInput) noteState.desiredRecipientName = toNameInput.value;
          if (toMailInput) noteState.desiredRecipientEmail = toMailInput.value;
          if (giftCheckbox) noteState.desiredIsGift = giftCheckbox.checked;
          renderGiftRow();
          renderNoteMeta("saving");
          scheduleCartNoteSave();
        });
        field.addEventListener("blur", function () {
          flushCartNote().catch(function () {});
        });
      });
    }

    syncIsGift();
    if (giftCheckbox) {
      noteState.desiredIsGift = giftCheckbox.checked;
    }
    renderGiftRow();
    renderNoteMeta();
    if (cartGiftDetailsAreDirty()) scheduleCartNoteSave();

    if (drawer.dataset.vcCartNavigationInitialized !== "true") {
      drawer.dataset.vcCartNavigationInitialized = "true";
      drawer.addEventListener("click", function (event) {
        var link = event.target.closest("a[href]");
        if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if ((!noteInput && !buyerNameInput && !giftCheckbox) || (!noteState.drainPromise && !cartGiftDetailsAreDirty())) return;

        event.preventDefault();
        var destination = link.href;
        flushCartNote().then(function () {
          window.location.assign(destination);
        }).catch(function () {});
      });
    }

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      if (form.dataset.vcCartFormInitialized === "true") return;
      form.dataset.vcCartFormInitialized = "true";

      form.addEventListener("submit", function (event) {
        if (event.defaultPrevented) return;
        var submitter = event.submitter || form.querySelector('[type="submit"]');
        var originalText = submitter ? submitter.textContent : "";

        event.preventDefault();
        showMessage("");
        if (submitter) {
          submitter.disabled = true;
          submitter.textContent = "Adding...";
        }

        fetch(addUrl, {
          method: "POST",
          headers: {
            "Accept": "application/json"
          },
          body: new FormData(form)
        }).then(function (response) {
          return response.json().then(function (payload) {
            if (!response.ok) {
              throw new Error(payload.description || payload.message || "Unable to add item.");
            }
            return payload;
          });
        }).then(function (item) {
          return fetchCart().then(function () {
            showMessage((item.product_title || item.title || "Item") + " added to your bag.");
            setOpen(true);
          });
        }).catch(function (error) {
          showMessage(error.message || "Unable to add item.", true);
          setOpen(true);
        }).finally(function () {
          if (submitter) {
            submitter.disabled = false;
            submitter.textContent = originalText;
          }
        });
      });
    });
  }

  function initAll(scope) {
    initMobileMenu(scope);
    initHeroSliders(scope);
    initAnimatedEyes(scope);
    initRegistryProductCards(scope);
    initCartDrawer();
  }

  window.VitaRegistryProductCards = {
    init: initRegistryProductCards
  };

  document.addEventListener("DOMContentLoaded", function () {
    initAll(document);
  });

  document.addEventListener("vita:content:loaded", function (event) {
    initAll(event.detail && event.detail.container ? event.detail.container : document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    cleanupHeroSliders(event.target);
    cleanupAnimatedEyes(event.target);
  });
})();
